<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchParams.per_page"
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Check"
                    pluralName="Checks"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="bank-account">Bank Account:</label>
                            <select class="form-control" id="bank-account" [(ngModel)]="searchParams['bank_account_id']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="bank_account.id" *ngFor="let bank_account of searchOptions.bank_accounts">{{bank_account.name}}</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="check-from">Check # From:</label>
                                <input class="form-control" type="text" id="check-from" name="check-from" [(ngModel)]="searchParams['check_number_from']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="check-to">Check # To:</label>
                                <input class="form-control" type="text" id="check-to" name="check-to" [(ngModel)]="searchParams['check_number_to']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="status">Status:</label>
                            <select class="form-control" id="status" [(ngModel)]="searchParams['search[status]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="status.id" *ngFor="let status of searchOptions.statuses">{{status.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="matter-name">Matter Name/Number:</label>
                            <!-- FIXED 2026-01-05: Added missing closing bracket ] in search param keys -->
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" (clearMatter)="searchParams['search[matter_id]'] = undefined" [matterId]="searchParams['search[matter_id]']" [small_input]="false" (matter_id)="searchParams['search[matter_id]']=$event"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <label for="contact-name">Payee Name:</label>
                            <!-- FIXED 2026-01-05: Added missing closing bracket ] in search param keys -->
                            <app-contact-search id="contact-name" [contactId]="searchParams['search[contact_id]']" (clearContact)="searchParams['search[contact_id]'] = undefined" [placeholder]="'Search and select'" [small_input]="false" (contact_id)="searchParams['search[contact_id]']=$event"></app-contact-search>
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="text" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderBy of searchOptions.order_by' [value]='orderBy.value'>{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox" (click)="searchParams['hide_voided'] = !searchParams['hide_voided']">
                            <input type="checkbox" class="custom-control-input" [checked]="searchParams['hide_voided']" [(ngModel)]="searchParams['hide_voided']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"/>
                            <label class="custom-control-label">Hide Voided</label>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                    </form>
                    <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                        <table class="table" style="transform: rotateX(180deg);">
                            <thead>
                                <tr>
                                    <th colspan="2">Bank Account Balances</th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr *ngFor="let bank_account_balance of bank_account_balances">
                                    <th><a routerLink="/checks" [queryParams]="{page: 1, per_page: 50, reversal: 'hide_reversed', bank_account_id: bank_account_balance.details.bank_account.id}">{{bank_account_balance.name}}</a></th>
                                    <td>${{bank_account_balance.details.balance}}</td>
                               </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <div class="row align-items-center pt-4">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <h2 class="mb-0 text-center">Checks</h2>
                    </div>
                    <div class="col-md-4 text-right">
                        <a class="btn btn-primary" id="new-disbursement-check" href="/checks/new">
                            <span class="fa fa-plus-circle mr-1"></span>
                            New Disbursement / Check
                        </a>
                    </div>
                </div>
                <hr class="mt-1 mb-2" />
                <tabset>
                    <tab heading="Checks" id="checks">
                        <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                            <table class="table" style="transform: rotateX(180deg);">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Group</th>
                                        <th>Matter</th>
                                        <th>Check</th>
                                        <th>S</th>
                                        <th>Payee</th>
                                        <th>Description</th>
                                        <th>Bank</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let check of checks">
                                        <td><a [ngClass]="{'lightblue': check.color_conditions.light_colored}" [href]="'/checks/' + check.id">{{check.id}}</a></td>
                                        <td><a [ngClass]="{'lightblue': check.color_conditions.light_colored}" [href]="'/entry_groups/' + check.entry_group_id">{{check.entry_group_id}}</a></td>
                                        <td><a [ngClass]="{'lightblue': check.color_conditions.light_colored}" [routerLink]="'/matters/' + check.matter_id">{{check.matter.number}}</a></td>
                                        <td><a [ngClass]="{'text-danger': check.negative_amount && !check.color_conditions.light_colored, 'lightsalmon': check.negative_amount && check.color_conditions.light_colored}" [href]="'/checks/' + check.id">{{check.check_number}}</a></td>
                                        <td [ngClass]="{'text-muted': check.color_conditions.light_colored}">{{check.status}}</td>
                                        <td>
                                            <a [ngClass]="{'text-muted': check.color_conditions.light_colored}" [routerLink]="'/companies/' + check.contact.id" *ngIf="check.contact.company_name">{{check.contact.display_name}}</a>
                                            <a [ngClass]="{'text-muted': check.color_conditions.light_colored}" [routerLink]="'/persons/' + check.contact.id" *ngIf="!check.contact.company_name">{{check.contact.display_name}}</a>
                                        </td>
                                        <td><span [ngClass]="{'text-muted': check.color_conditions.light_colored}" [innerHTML]="check.description | safeHtml"></span></td>
                                        <td><a [href]="'/bank_accounts/' + check.bank_account.id">{{check.bank_account.name}}</a></td>
                                        <td [ngClass]="{'text-muted': check.color_conditions.light_colored}">{{check.date}}</td>
                                        <td class="text-right">
                                            <span *ngIf="check.amount" [ngClass]="{'text-danger': check.negative_amount && !check.color_conditions.light_colored, 'lightsalmon': check.negative_amount && check.color_conditions.light_colored}">{{check.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                            <span *ngIf="!check.amount"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </tab>
                    <tab heading="Clear Checks" id="clear-checks">
                        <tabset>
                            <tab [heading]="clearCheckTab.title" *ngFor="let clearCheckTab of clearCheckTabs">
                                <div id="checkTabDiv" class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                                    <table class="table" style="transform: rotateX(180deg);">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>ID</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let content of clearCheckTab.content; let i = index">
                                                <td>
                                                    <div id="clear-check-input" class="form-group form-check">
                                                        <input type="checkbox" class="form-check-input" (click)="buildCreateParams({commit:'Clear Checks', bank_id: clearCheckTab.checkObject.bank_id, check_id: clearCheckTab.checkObject.id[i]})">
                                                    </div>
                                                </td>
                                                <td [innerHtml]="content.id | safeHtml"></td>
                                                <td class="text-right">
                                                    <span *ngIf="!content.amount">{{ content.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                                    <span *ngIf="!content.amount"></span>
                                                </td>
                                                <td [innerHtml]="content.description | safeHtml"></td>
                                            </tr>
                                            <tr>
                                                <div class="form-group"><app-button [small]="true" (onClick)="create()">Clear Checks</app-button></div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </tab>
                        </tabset>
                    </tab>
                    <tab heading="Print Checks" id="print-checks">
                        <tabset>
                            <tab [heading]="printCheckTab.title" *ngFor="let printCheckTab of printCheckTabs">
                                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                                    <table class="table" style="transform: rotateX(180deg);">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>ID</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let content of printCheckTab.content; let i = index">
                                                <td>
                                                    <div id="print-check-input" class="form-group form-check">
                                                        <input type="checkbox" class="form-check-input" (click)="buildCreateParams({commit:'Print Checks', bank_id: printCheckTab.checkObject.bank_id, check_id: printCheckTab.checkObject.id[i]})">
                                                    </div>
                                                </td>
                                                <td [innerHtml]="content.id | safeHtml"></td>
                                                <td class="text-right">
                                                    <span *ngIf="!content.amount">{{ content.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                                    <span *ngIf="!content.amount"></span>
                                                </td>
                                                <td [innerHtml]="content.description | safeHtml"></td>
                                            </tr>
                                            <tr>
                                                <div class="form-group"><app-button [small]="true" (onClick)="create()">Print Checks</app-button></div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </tab>
                        </tabset>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
